var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 1.75586C21.0456 1.75586 24 4.76179 24 8.9701C24 17.3867 15 22.1962 12 23.9998C9 22.1962 0 17.3867 0 8.9701C0 4.76179 3 1.75586 6.6 1.75586C8.832 1.75586 10.8 2.95823 12 4.16061C13.2 2.95823 15.168 1.75586 17.4 1.75586Z",
    fill: "url(#paint0_linear_8019_207236)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.16061C10.8 2.95823 8.832 1.75586 6.6 1.75586C3 1.75586 0 4.76179 0 8.9701C0 16.9068 8.00299 21.6361 11.4311 23.6618C11.6384 23.7843 11.829 23.8969 12 23.9998C12.171 23.8969 12.3616 23.7843 12.5689 23.6618C15.997 21.636 24 16.9068 24 8.9701C24 4.76179 21.0456 1.75586 17.4 1.75586C15.168 1.75586 13.2 2.95823 12 4.16061ZM12 22.199C13.6168 21.2414 15.9898 19.811 18.1045 17.8132C20.5781 15.4763 22.4882 12.5563 22.4882 8.9701C22.4882 5.57141 20.1607 3.31683 17.4 3.31683C15.6773 3.31683 14.0669 4.26475 13.0528 5.28083L12 6.33575L10.9472 5.28083C9.93309 4.26475 8.32266 3.31683 6.6 3.31683C3.87822 3.31683 1.51181 5.57853 1.51181 8.9701C1.51181 12.5563 3.42193 15.4763 5.89554 17.8132C8.01023 19.811 10.3832 21.2414 12 22.199Z",
    fill: "#D4E0E7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89134 4.29712C2.10217 5.18117 0.952441 5.24015 0 5.38274C1.02047 5.59662 2.22223 5.9722 2.89134 6.69845C3.84378 7.73222 3.84378 9.76735 3.97984 11.122C4.11591 9.8743 4.37345 7.69657 5.22385 6.69845C5.92238 5.87856 7.60819 5.43027 8.50394 5.38274C7.63087 5.38274 5.87015 4.99386 5.22385 4.4235C4.41597 3.71056 4.09323 1.24765 3.97984 0C3.94583 1.1526 3.6805 3.41306 2.89134 4.29712Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8019_207236",
    x1: 7.93701,
    y1: 1.75586,
    x2: 14.356,
    y2: 25.1661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.246527,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9BCC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverHeartIcon);
export default __webpack_public_path__ + "static/media/silver-heart-icon.9bac77567939e5e6b8a71222af272e79.svg";
export { ForwardRef as ReactComponent };